import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Check, FullScreenEnter, FullScreenOut, ZoomIn, ZoomOut } from "@air/next-icons";
import { Button } from "@air/primitive-button";
import { IconButton } from "@air/primitive-icon-button";
import { Tooltip } from "@air/primitive-tooltip";
import classNames from "classnames";
import { forwardRef, memo } from "react";
import { useAssetHotkeys } from "~/components/AssetModal/Visualizer/shared/useAssetHotkeys";
import { MAX_ZOOM, MIN_ZOOM } from "../shared/constants";
const ForwardedImageVisualizerControls = /*#__PURE__*/ forwardRef((param, ref)=>{
    let { isFullscreen, isShowOriginal = false, onShowOriginalChange, onToggleFullScreen, onZoomIn, onZoomOut, zoom } = param;
    useAssetHotkeys({
        zoomOut: onZoomOut,
        zoomIn: onZoomIn,
        openFullscreen: onToggleFullScreen,
        isFullscreen
    });
    return /*#__PURE__*/ _jsx("div", {
        ref: ref,
        className: classNames("pointer-events-none absolute bottom-8 left-0 z-[5] flex h-12 w-full justify-center px-8", isFullscreen ? "bottom-6 h-14" : undefined),
        children: /*#__PURE__*/ _jsxs("div", {
            className: "pointer-events-none relative flex size-full max-w-[600px] items-center justify-center gap-2 rounded-8 bg-black/80 px-3 py-2 opacity-0 backdrop-blur transition-opacity duration-200 ease-in-out group-hover/visualizer:pointer-events-auto group-hover/visualizer:opacity-100",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "absolute left-3 top-0 flex h-full items-center justify-start gap-2",
                    children: !!onShowOriginalChange && /*#__PURE__*/ _jsx(Button, {
                        appearance: "ghost",
                        color: "grey",
                        onClick: ()=>onShowOriginalChange(!isShowOriginal),
                        prefix: isShowOriginal ? /*#__PURE__*/ _jsx(Check, {
                            className: "size-4"
                        }) : null,
                        size: "small",
                        children: "Show original"
                    })
                }),
                /*#__PURE__*/ _jsx(Tooltip, {
                    label: "Zoom out",
                    children: /*#__PURE__*/ _jsx(IconButton, {
                        appearance: "ghost",
                        className: "disabled:bg-transparent disabled:text-grey-8",
                        color: "grey",
                        disabled: zoom === MIN_ZOOM,
                        icon: ZoomOut,
                        label: "Zoom out",
                        onClick: ()=>onZoomOut(),
                        size: "small"
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "flex h-full min-w-[40px] items-center justify-center text-center",
                    children: /*#__PURE__*/ _jsx("div", {
                        className: classNames("text-12 font-medium text-grey-10", isFullscreen ? "text-ui-14" : "text-ui-12"),
                        children: "".concat(Math.round(100 * zoom), "%")
                    })
                }),
                /*#__PURE__*/ _jsx(IconButton, {
                    appearance: "ghost",
                    className: "disabled:bg-transparent disabled:text-grey-8",
                    color: "grey",
                    disabled: zoom === MAX_ZOOM,
                    icon: ZoomIn,
                    label: "Zoom in",
                    onClick: onZoomIn,
                    size: "small"
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "absolute right-3 top-0 flex h-full items-center justify-end gap-2",
                    children: /*#__PURE__*/ _jsx(IconButton, {
                        appearance: "ghost",
                        color: "grey",
                        icon: isFullscreen ? FullScreenOut : FullScreenEnter,
                        label: isFullscreen ? "Exit fullscreen" : "Enter fullscreen",
                        onClick: onToggleFullScreen,
                        size: "small"
                    })
                })
            ]
        })
    });
});
export const ImageVisualizerControls = /*#__PURE__*/ memo(ForwardedImageVisualizerControls);
ForwardedImageVisualizerControls.displayName = "ImageVisualizerControls";
ImageVisualizerControls.displayName = "MemoizedImageVisualizerControls";
